
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { TopicItemProps } from ".";
import { loading, endLoading } from "store/topic";

interface ApiTopicRemoveInputProps {
    ids: number[]
}

type ApiTopicRemoveOutputProps = OutputBaseProps<{ item: TopicItemProps; }>;

export const apiTopicRemove = async (data: ApiTopicRemoveInputProps) => {
    store.dispatch(loading());
    const res = (await axios.delete<ApiTopicRemoveOutputProps>("/api/topic/remove", { data }))
        .data;
    store.dispatch(endLoading());
    return res;
};